<template>
<h1 class="text-center">ScrollToPlugin</h1>
</template>

<script>
export default {
  name: "ScrollToPlugin"
}
</script>

<style scoped>

</style>